import React from "react";
import { DownloadIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";
import { ModalButton } from "../CommonComponents/ModalButton";
import { useModal } from "../CommonComponents/useModal";
import { ExportModal } from "./ExportModal";
import { hasAccess } from "../utils/hasAccess";
import { useMeQuery } from "../store/woolitApi";

export const ExportButton = () => {
  const { isShown, toggle } = useModal();
  const { t } = useTranslation();
  const { data: user } = useMeQuery();

  if (!hasAccess(user, "export")) {
    return null;
  }

  return (
    <ModalButton
      modalContent={<ExportModal />}
      isShown={isShown}
      toggle={toggle}
      headerText={t("export.export")}
    >
      <DownloadIcon />
    </ModalButton>
  );
};
